import NoActiveTaskIcon from '@cp/src/assets/icons/NoActiveTaskIcon';
import { Button, Typography } from '@navi/web-ui/lib/primitives';
import { INoTicketsFound } from '../../types';

const NoTicketsFound = (props: INoTicketsFound) => {
  const { toggleRequestFormDrawer } = props;

  return (
    <div className="flex flex-col justify-center items-center h-full">
      <NoActiveTaskIcon />
      <Typography variant="h4" color="var(--navi-color-gray-c2)" className="mt-6">
        No active tasks for this customer
      </Typography>
      <Button onClick={toggleRequestFormDrawer} className="w-[200px] mt-2" type="submit">
        Create new task
      </Button>
    </div>
  );
};

export default NoTicketsFound;
